import React from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { Check, ChevronDown } from 'lucide-react';

export const Select = ({
  value,
  onValueChange,
  options,
  placeholder = "Seçiniz...",
  disabled = false,
  error = false,
  className = ""
}) => {
  return (
    <SelectPrimitive.Root value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectPrimitive.Trigger
        className={`w-full px-4 py-2.5 text-left bg-white border border-gray-300 rounded-lg shadow-sm transition-colors hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-[#7a2c2c] focus:border-[#7a2c2c] disabled:bg-gray-100 disabled:cursor-not-allowed flex items-center justify-between ${error ? 'border-red-500' : ''} ${className}`}
      >
        <SelectPrimitive.Value placeholder={placeholder} />
        <SelectPrimitive.Icon>
          <ChevronDown className="w-4 h-4 text-gray-500" />
        </SelectPrimitive.Icon>
      </SelectPrimitive.Trigger>

      <SelectPrimitive.Portal>
        <SelectPrimitive.Content
          className="overflow-hidden bg-white rounded-lg shadow-lg border border-gray-200 z-50"
          position="popper"
          sideOffset={5}
        >
          <SelectPrimitive.Viewport className="p-1">
            {options.map((option) => (
              <SelectPrimitive.Item
                key={option.value}
                value={option.value}
                className="relative flex items-center px-8 py-2 text-sm rounded-md cursor-pointer select-none hover:bg-gray-100 focus:bg-gray-100 focus:outline-none data-[disabled]:opacity-50 data-[disabled]:pointer-events-none"
              >
                <SelectPrimitive.ItemIndicator className="absolute left-2">
                  <Check className="w-4 h-4 text-[#7a2c2c]" />
                </SelectPrimitive.ItemIndicator>
                <SelectPrimitive.ItemText>{option.label}</SelectPrimitive.ItemText>
              </SelectPrimitive.Item>
            ))}
          </SelectPrimitive.Viewport>
        </SelectPrimitive.Content>
      </SelectPrimitive.Portal>
    </SelectPrimitive.Root>
  );
};
